module.exports = __webpack_public_path__ + "assets/img/12december_light.c5079ce6.jpeg";